import SingleTnC from './SingleTnC'
export default SingleTnC
